module.exports = __webpack_public_path__ + "static/media/roadmap_img.b971b35f.png";